"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
var en = {
  mhForm: {
    required: '%l cannot be empty',
    min: '%l cannot be less than %v',
    max: '%l cannot be greater than %v',
    minLen: '%l length cannot be less than %v',
    maxLen: '%l length cannot be greater than %v',
    isPhone: '%l is not a mobile phone number format',
    pattern: '%l format is incorrect',
    isEmail: '%l is not a mailbox format'
  }
};
exports.en = en;